import {AppBar, Button, Dialog, Grid, IconButton, Toolbar, Typography} from '@material-ui/core';

import {useState} from 'react';
import {useParams} from 'react-router-dom';
import CloseIcon from '@material-ui/icons/Close';
import {ContactsPanel} from '../Contacts/Contacts';

export default function SelectContact({contactSelected}: {contactSelected: (email: string) => void}) {
    const {historyFormId} = useParams<any>();
    const [open, setOpen] = useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <div>
            <Button
                disabled={historyFormId}
                variant="outlined"
                color="primary"
                style={{marginTop: 12, width: '100%'}}
                onClick={handleClickOpen}
            >
                Assign Contact
            </Button>
            <Dialog fullScreen open={open} onClose={handleClose}>
                <AppBar style={{position: 'relative'}}>
                    <Toolbar>
                        <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
                            <CloseIcon />
                        </IconButton>
                        <Typography variant="h6" style={{marginLeft: 2, flex: 1}}>
                            Assign Contact
                        </Typography>
                        <Button autoFocus color="inherit" onClick={handleClose}>
                            save
                        </Button>
                    </Toolbar>
                </AppBar>
                <Grid container spacing={3}>
                    <Grid item xs={12} style={{padding: 30}}>
                        <ContactsPanel
                            selectContact={(email) => {
                                handleClose();
                                contactSelected(email);
                            }}
                        />
                    </Grid>
                </Grid>
            </Dialog>
        </div>
    );
}
